<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: LoadingSpinner                                        |
| Section: atoms                                                   |
| Purpose: Reusable spinner indicator for pending async actions.   |
+------------------------------------------------------------------+
-->
<template>
    <div class="loader">
        <svg class="spinner" viewBox="0 0 50 50">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'LoadingSpinner'
};
</script>

<style scoped>
/* Styles are inherited from global.css */
</style>
